import { createSlice } from '@reduxjs/toolkit';
import CentersService from 'services/CentersService';
import PackageService from 'services/PackageService';
import { toast } from './notificationReducer';
import { packagesTexts } from 'locale/es';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

// TODO: Faltan create, edit, delete and reset

const packagesBusinessSlice = createSlice({
  name: 'businessPackage',
  initialState,
  reducers: {
    setBusinessPackage(state, action) {
      const { data } = action.payload;

      return { ...state, data, loading: false, error: null };
    },
    appendBusinessPackage(state, action) {
      const { data } = action.payload;

      return {
        ...state,
        data: [...state.data, data],
        loading: false,
        error: null,
      };
    },
    updateBusinessPackage(state, action) {
      const { data } = action.payload;

      const updatedBusinessPackage = state.data.map((businessPackage) =>
        businessPackage.id !== data.id ? businessPackage : data
      );

      return {
        ...state,
        data: updatedBusinessPackage,
        loading: false,
        error: null,
      };
    },
    setBusinessPackageLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setBusinessPackageError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetBusinessPackageState(state, action) {
      return initialState;
    },
  },
});

export const { setBusinessPackage, appendBusinessPackage, updateBusinessPackage, setBusinessPackageLoading, setBusinessPackageError, resetBusinessPackageState } = packagesBusinessSlice.actions;

export const initializeBusinessPackage = () => {
  return async (dispatch) => {
    try {
      dispatch(setBusinessPackageLoading());

      const { data } = await CentersService.getPackages();
      dispatch(setBusinessPackage({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setBusinessPackageError({
          message: error.message,
          status: error.response?.status,
        })
      );
      dispatch(toast(packagesTexts.LOADING_ERROR, 'error'));
    }
  };
};

export const createBusinessPackage = (centerId, packageObject) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await PackageService.create(centerId, packageObject);
      dispatch(appendBusinessPackage({ data }));
      dispatch(toast(packagesTexts.CREATED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setBusinessPackageError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export const updateBusinessPackageAction = (packageId, packageObject) => {
  return async (dispatch) => {
    try {
      const { data } = await PackageService.update(packageId, packageObject);
      dispatch(updateBusinessPackage({ data }));
      dispatch(toast(packagesTexts.EDITED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setBusinessPackageError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export default packagesBusinessSlice.reducer;
